<template>
  <div class="certificados">
    <div class="certificado-principal py-5 border-top bg-light">
      <titulo-seccion class="pb-3">Certificados</titulo-seccion>
      <div class="mx-auto text-center">
        <div class="contenedor-img-principal" v-for="(item,index) in Certificados" :key="index">
          <img :src="item.imagen" :title="item.nombre" :alt="item.nombre" />
        </div>
      </div>
    </div>
    <div class="contenedor-firmas py-5 ">
      <div class="contenedor-certificados d-flex justify-content-center flex-wrap">
        <titulo-seccion class="pb-3 w-100">Paneles de Firmas</titulo-seccion>
        <div class="contenedor-firma" v-for="(item,index) in PanelesFirma" :key="index">
          <div class="contenedor-img-firma">
            <img :src="item.imagen" :title="item.nombre" :alt="item.nombre" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Certificados: [
        {
          nombre: "dgii",
          imagen: require("@/assets/images/certificados/dgii-newlogo.png")
        }
      ],
      PanelesFirma: [
        {
          nombre: "CARDNET",
          imagen: require("@/assets/images/certificados/cardnet.png")
        },
        {
          nombre: "VisaNet",
          imagen: require("@/assets/images/certificados/visa.png")
        },
        {
          nombre: "AZUL",
          imagen: require("@/assets/images/certificados/azul.png")
        }
      ]
    };
  }
};
</script>
<style scoped>
.certificado-principal,
.contenedor-firmas {
  padding: 0 6%;
}
/* Contenedor Principal */
h1 {
  color: #262626;
}
.contenedor-img-principal {
  margin: auto;
  width: 340px;
}
.contenedor-img-principal img {
  height: 140px;
  width: auto !important;
}
/* ------ */
/* Firmas */
.contenedor-firma {
  width: 300px;
}
.contenedor-img-firma {
  display: block;
  margin: auto;
  width: 300px;
  text-align: center;
}
.contenedor-img-firma img {
  height: 130px;
  width: auto !important;
}
/* ------ */
</style>